<template>
  <div class="table_container" :class="[showBorder && 'table-border', variant]">
    <table id="table" cellspacing="0">
      <thead v-if="showLabels">
        <tr>
          <th
            v-for="table in columns"
            :key="table"
            :style="{
              textAlign: table?.align,
              minWidth: table?.minWidth,
            }"
          >
            <p
              @click="table?.onClick"
              :class="[
                table?.onClick && 'cursor-pointer',
                sortBy === table?.id && 't-white',
              ]"
            >
              {{ table.label }}
            </p>
          </th>
        </tr>
      </thead>
      <transition name="opacity" mode="out-in">
        <tbody v-if="!isLoading">
          <tr
            v-for="(item, index) in items"
            :key="item"
            v-on:click="(e) => openDetail(e, item)"
            :class="[disabled && 'disabled']"
          >
            <td
              v-for="(table, ind) in columns"
              :key="`${table.id}-${ind}-${index}`"
              :class="table.id"
              :style="{
                textAlign: table.align,
                minWidth: table.minWidth,
              }"
            >
              <table-user
                v-if="table.id === 'payout_user'"
                :image="item.user?.avatar"
                :email="item.user?.email"
                :name="item.user?.username"
                :is-single-s-s="item?.is_single_ss || false"
              />
              <table-user
                v-if="table.id === 'user'"
                :image="item.avatar"
                :name="item.username"
                :rank="item?.rank?.image"
                :email="item.email"
                :subscription="item?.subscription"
              />
              <GoldSeller
                v-if="table.id === 'gold_seller'"
                :avatar="item.user_avatar"
                :online="item.user_online"
                :username="item.user_username"
                :total-reviews="item.total_reviews"
                :review-percentage="item.positive_reviews"
              />
              <GoldPrice v-if="table.id === 'gold_price'" :price="item.price" />
              <!-- <GoldDetail
                v-if="table.id === 'gold_details'"
                :servers="item.servers"
                :factions="item.factions"
                :realms="item.realms"
              /> -->
              <GoldDetail
                v-if="table.id === 'gold_servers'"
                :servers="item.servers"
              />
              <GoldDetail
                v-if="table.id === 'gold_factions'"
                :factions="item.factions"
              />
              <GoldDetail
                v-if="table.id === 'gold_realms'"
                :realms="item.realms"
              />
              <order-detail
                v-if="table.id === 'order_detail'"
                :order-details="item.order_details"
              />
              <boost-type
                v-else-if="table.id === 'game_pack'"
                :game-pack="item.game_pack"
                :invoice-code="item.invoice_code"
                :game="item.game"
              />
              <payment-type
                v-else-if="table.id === 'payment_type'"
                :type="item.type"
              />
              <div
                class="d-flex-row"
                v-else-if="
                  table.id === 'platform' && item?.platform?.image_dark
                "
              >
                <img
                  :src="item.platform.image_dark"
                  width="24"
                  height="24"
                  alt="Game platform image"
                />
              </div>
              <order-date
                v-else-if="table.id === 'order_date'"
                :status="item.status"
                :createdAt="item?.created_at"
              />
              <order-booster
                v-else-if="table.id === 'booster'"
                :order-booster="item.booster"
              />
              <order-type
                v-else-if="table.id === 'order_type'"
                :game-pack="item.game_pack"
                :type="item.type"
              />
              <order-resource
                v-else-if="table.id === 'order_resource'"
                :game="item.game"
                :game-image="item.game_image"
                :type="item.type"
                :message="item?.message || ''"
                :invoice-code="item?.invoice_code || ''"
                :is-single-ss="item?.is_single_ss || false"
              />
              <withdraw-status
                v-else-if="table.id === 'withdraw_status'"
                :amount="item.amount"
                :payout-status="item.payout_status || null"
              />
              <table-cashback
                v-else-if="table.id === 'cashback'"
                :cashback-amount="item.cashback_amount"
                :is-membership="item.is_membership"
              />
              <BoosterOrderStatus
                v-else-if="table.id === 'booster_order_status'"
                :is-available="item.active_orders > 0 ? false : true"
                :order-count="item.active_orders"
                :self-play-count="item.self_play"
              />
              <HiringStatus
                v-else-if="table.id === 'hiring_request_status'"
                :status="item.status"
              />
              <div
                class="d-flex-row justify-start"
                v-else-if="table.id === 'games'"
              >
                <img
                  v-for="game in [...item?.games].slice(0, 4)"
                  :key="game"
                  :src="game.image"
                  height="20"
                  width="20"
                  alt="Game platform icon"
                />
                <img
                  v-for="game in [...item?.mmo_games].slice(0, 4)"
                  :key="game"
                  :src="game.image"
                  height="20"
                  width="20"
                  alt="Game platform icon"
                />
              </div>
              <div
                class="d-flex-row justify-start"
                v-else-if="table.id === 'platforms'"
              >
                <img
                  v-for="platform in item?.platforms"
                  :key="platform"
                  :src="platform.image_dark"
                  height="20"
                  width="20"
                  alt="Game platform icon"
                />
              </div>
              <div
                class="d-flex-row justify-start"
                v-else-if="table.id === 'hiring_ranks'"
              >
                <label
                  class="t-white regular-s font-family-2"
                  :key="rank"
                  v-for="rank in item?.ranks"
                  >{{ rank }}</label
                >
              </div>
              <div
                class="d-flex-row justify-start"
                v-else-if="table.id === 'hiring_regions'"
              >
                <label class="t-white regular-s font-family-2">{{
                  item?.servers?.join(", ")
                }}</label>
              </div>
              <div
                class="d-flex-row justify-start"
                v-else-if="table.id === 'hiring_country'"
              >
                <p class="t-white regular-s caps font-family-2">
                  {{ item?.country }}
                </p>
              </div>
              <chip
                v-else-if="table.id === 'order_status' && isAcceptedOrder(item)"
                :variant="item.status !== 2 ? 'process' : 'completed'"
                size="medium"
                :text="
                  handleOrderStatus(
                    item.status,
                    item?.booster,
                    item?.deleted_at
                  )
                "
              />
              <chip
                v-else-if="table.id === 'verification'"
                :variant="item.user.verification ? 'verified' : 'danger'"
                size="medium"
                :text="!item.user.verification ? 'Not Verified' : 'Verified'"
              />
              <button
                class="small height-30 width-100 primary filled b-radius-4 t-black font-family-1 regular-m f-w-600"
                v-else-if="
                  table.id === 'order_status' && !isAcceptedOrder(item)
                "
                @click.stop="acceptOrder(item.invoice_code)"
              >
                {{ $t("order.card.accept") }}
              </button>
              <chip
                v-else-if="
                  table.id === 'widthdraw_status_chip' &&
                  item.payout_status === 1
                "
                variant="process"
                size="medium"
                text="Pending"
              />
              <chip
                v-else-if="
                  table.id === 'widthdraw_status_chip' &&
                  item.payout_status === 2
                "
                variant="completed"
                size="medium"
                text="Completed"
              />
              <div v-else-if="table.id === 'delete'">
                <button
                  class="primary outlined-color medium b-radius-6 font-family-1 height-36 regular-l f-w-600"
                  @click.stop="onDelete(item)"
                >
                  {{ $t("dashboard.delete") }}
                </button>
              </div>
              <div v-else-if="table.id === 'edit'">
                <button
                  class="primary outlined-color medium b-radius-6 font-family-1 height-36 regular-l f-w-600"
                  @click.stop="onEdit(item)"
                >
                  {{ $t("dashboard.edit") }}
                </button>
              </div>
              <div
                class="d-flex-row justify-start"
                v-else-if="table.id === 'gold_stock'"
              >
                <label class="medium-l font-family-2 t-white">{{
                  item.in_stock
                }}</label>
              </div>
              <div
                class="d-flex-row justify-start"
                v-else-if="table.id === 'gold_min_purchase'"
              >
                <label class="medium-l font-family-2 t-white">{{
                  item.min_purchase
                }}</label>
              </div>
              <NuxtLinkLocale
                :to="`/dashboard/orders/${item.last_completed_order?.invoice_code}`"
                @click.stop=""
                target="_blank"
                v-else-if="
                  table.id === 'last_order' && item?.last_completed_order
                "
                class="d-flex-column justify-start align-start booster_rating gap-0"
              >
                <!-- <p class="t-white font-family-1 regular-l f-w-600">
                  #{{ item.last_completed_order?.invoice_code }}
                </p> -->
                <p class="t-grey font-family-2 regular-s">
                  Last order completed:
                  <span class="t-white">{{
                    timestampToDateTime(
                      item.last_completed_order?.order_end_date
                    )
                  }}</span>
                  -
                  <span class="t-white">{{
                    formatDaysDifference(
                      item.last_completed_order?.order_end_date,
                      new Date().toISOString()
                    )
                  }}</span>
                </p>
              </NuxtLinkLocale>
              <div
                v-else-if="
                  table.id === 'last_order' && !item?.last_completed_order
                "
                class="d-flex-column booster_rating justify-start align-start"
              >
                <p class="t-grey font-family-2 regular-s">
                  Completed At:
                  <span class="t-white">N/A</span>
                </p>
              </div>
              <p
                v-else-if="table.id === 'email'"
                class="t-white medium-l font-family-2"
              >
                {{ restrictEmail(item[table.id], getUser?.secondary_role_id) }}
              </p>
              <p
                v-else-if="table.id === 'username'"
                class="t-white medium-l font-family-2"
              >
                {{ item[table.id] }}
              </p>
              <p
                v-else-if="table.id === 'code'"
                class="t-white medium-l font-family-2"
              >
                {{ item[table.id] }}
              </p>
              <p
                v-else-if="
                  table.id === 'payout_wallet' &&
                  item?.payout_method === 'Binance'
                "
                class="t-white medium-l font-family-2"
              >
                Wallet is: {{ item?.payout_method_detail?.usdt_trc20 }}
              </p>
              <p
                v-else-if="
                  table.id === 'payout_wallet' &&
                  item?.payout_method === 'Payoneer USD'
                "
                class="t-white medium-l font-family-2"
              >
                Account Number: {{ item?.payout_method_detail?.account_number }}
              </p>
              <p
                v-else-if="
                  table.id === 'payout_wallet' && item?.payout_method === 'Wise'
                "
                class="t-white medium-l font-family-2"
              >
                Wise Email: {{ item?.payout_method_detail?.email }}
              </p>
              <p
                v-else-if="
                  table.id === 'payout_wallet' &&
                  item?.payout_method === 'Payoneer EUR'
                "
                class="t-white medium-l font-family-2"
              >
                iBan Number: {{ item?.payout_method_detail?.iban }}
              </p>
              <p
                v-else-if="table.id === 'coupon_game'"
                class="t-white medium-l font-family-2"
              >
                {{
                  item?.game?.short_title
                    ? $t(item.game.short_title)
                    : "Any Game"
                }}
              </p>
              <p
                v-else-if="table.id === 'coupon_type'"
                class="t-white medium-l font-family-2"
              >
                -{{ item.discount }}{{ handleCouponType(item.usage_type) }}
              </p>
              <label
                v-else-if="table.id === 'created_at'"
                class="t-white medium-l font-family-2"
              >
                {{ parseDate(item[table.id]) }}
              </label>
              <p
                v-else-if="table.id === 'created_at_ip'"
                class="t-white medium-l font-family-2"
              >
                {{ parseDate2(item["created_at"], item["user"]) }}

                <span class="regular-s t-light">(Europe/Rome)</span>
                <!-- <br />
                {{ parseDate2(item["created_at"], null) }}
                <span class="regular-s t-light" v-if="item['user']"
                  >(Europe/Rome)</span
                > -->
              </p>
              <p
                v-else-if="table.id === 'payment_method'"
                class="t-white medium-l font-family-2"
              >
                {{ item[table.id]?.title }}
                <span class="t-grey"></span>
              </p>
              <p
                v-else-if="table.id === 'withdraw_date'"
                class="t-white medium-l font-family-2"
              >
                {{ parseOrderDate(item.created_at) }}
              </p>
              <p
                class="medium-13 t-white medium-m font-family-2 f-w-600"
                v-else-if="table.id === 'withdraw_amount'"
              >
                <span
                  class="t-green"
                  v-if="item.amount > 0 || item.request_amount > 0"
                  >+</span
                ><span
                  class="t-pink"
                  v-else-if="item.amount < 0 || item.request_amount < 0"
                  >-</span
                >
                ${{ Math.abs(item.amount || item.request_amount).toFixed(2) }}
              </p>
              <p
                class="medium-13 t-white medium-m font-family-2 f-w-600"
                v-else-if="table.id === 'new_safe_balance_amount'"
              >
                ${{ Math.abs(item[table.id]).toFixed(2) }}
              </p>
              <p
                class="medium-13 t-white medium-m font-family-2 f-w-600"
                v-else-if="table.id === 'requested_at'"
              >
                {{ item?.requested_at }}
              </p>
              <kebab-icon v-else-if="table.id === 'menu'" />
              <p
                class="medium-13 t-white medium-m font-family-2 f-w-600"
                v-else-if="table.id === 'amount'"
              >
                {{ getUserCurrencyCode
                }}{{ parseFloat(item.amount).toFixed(2) }}
              </p>
              <p
                class="medium-13 t-white medium-m font-family-2 f-w-600"
                v-else-if="table.id === 'order_amount'"
              >
                {{ getUserCurrencyCode
                }}{{ parseFloat(item.amount).toFixed(2) }}
              </p>
              <p
                class="medium-13 t-white medium-m font-family-2 f-w-600"
                v-else-if="table.id === 'possible_request_amount'"
              >
                ${{ showPayoutPrice(item) }}
              </p>
              <p
                class="medium-13 t-white font-family-2 medium-l"
                v-else-if="table.id === 'payout_role'"
              >
                Booster
              </p>
              <label
                class="medium-13 t-white font-family-2 medium-l"
                v-else-if="table.id === 'ip'"
              >
                {{ item[table.id] }}
              </label>
              <label
                class="medium-13 t-white font-family-2 medium-l"
                v-else-if="table.id === 'name'"
              >
                {{ item[table.id] }}
              </label>
              <p
                class="medium-13 t-white font-family-2 medium-l"
                v-else-if="item[table.id]"
              >
                {{ item[table.id] }}
              </p>
            </td>
          </tr>
        </tbody>
        <tbody v-else-if="isLoading">
          <tr
            v-for="(item, index) in [1, 2, 3, 4]"
            :key="item"
            class="skeleton-able"
          >
            <td
              v-for="(table, ind) in columns"
              :key="`${table.id}-${ind}-${index}`"
            ></td>
          </tr>
        </tbody>
      </transition>
    </table>
  </div>
</template>

<script setup>
import { defineAsyncComponent } from "vue";
const BoostType = defineAsyncComponent(() =>
  import("../common/table/BoostType.vue")
);
const OrderDetail = defineAsyncComponent(() =>
  import("../common/table/OrderDetail.vue")
);
const OrderDate = defineAsyncComponent(() =>
  import("../common/table/OrderDate.vue")
);
const OrderBooster = defineAsyncComponent(() =>
  import("../common/table/OrderBooster.vue")
);
const Chip = defineAsyncComponent(() => import("./Chip.vue"));
const TableCashback = defineAsyncComponent(() =>
  import("../common/table/TableCashback.vue")
);
const WithdrawStatus = defineAsyncComponent(() =>
  import("../common/table/WithdrawStatus.vue")
);
const OrderType = defineAsyncComponent(() =>
  import("../common/table/OrderType.vue")
);
const PaymentType = defineAsyncComponent(() =>
  import("../common/table/PaymentType.vue")
);
const OrderResource = defineAsyncComponent(() =>
  import("../common/table/OrderResource.vue")
);
const TableUser = defineAsyncComponent(() =>
  import("../common/table/TableUser.vue")
);
const BoosterOrderStatus = defineAsyncComponent(() =>
  import("../common/table/BoosterOrderStatus.vue")
);
const HiringStatus = defineAsyncComponent(() =>
  import("../common/table/HiringStatus.vue")
);

const GoldSeller = defineAsyncComponent(() =>
  import("../common/table/GoldSeller.vue")
);
const GoldDetail = defineAsyncComponent(() =>
  import("../common/table/GoldDetail.vue")
);
const GoldPrice = defineAsyncComponent(() =>
  import("../common/table/GoldPrice.vue")
);

import KebabIcon from "../icons/KebabIcon.vue";

import { computed } from "vue";

// HOOKS
const { getUser, getUserCurrencyCode } = useUserStore();
const { t } = useI18n();
const {
  tableColumns,
  items,
  openDetail,
  onDelete,
  onEdit,
  viewItem,
  acceptOrder,
  showLabels,
  disabled,
  showBorder,
  isLoading,
  achievementsActive,
  boosterPlacementColors,
  boosterDefaultRank,
  currentgameid,
  variant,
} = defineProps({
  tableColumns: {
    type: Array,
    required: true,
  },
  items: {
    type: Array,
    required: true,
  },
  openDetail: {
    type: Function,
    default: () => {},
  },
  onDelete: {
    type: Function,
    default: () => {},
  },
  onEdit: {
    type: Function,
    default: () => {},
  },
  viewItem: {
    type: Function,
    default: () => {},
  },
  acceptOrder: {
    type: Function,
    default: () => {},
  },
  showLabels: {
    type: Boolean,
    default: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  showBorder: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  achievementsActive: {
    type: Boolean,
    default: false,
  },
  boosterPlacementColors: {
    type: Boolean,
    default: true,
  },
  boosterDefaultRank: {
    type: Number,
    default: 1,
  },
  currentgameid: {
    type: Number,
    default: 1,
  },
  variant: {
    type: String,
    default: "",
  },
  sortBy: {
    default: null,
  },
});

const columns = computed(() => {
  return tableColumns || [];
});

// METHODS
const isAcceptedOrder = (order) => {
  const isMy = order?.is_my || false;
  if (getUser.role_id !== 3) {
    return true;
  } else if (isMy && getUser.role_id === 3) {
    return true;
  } else if (!isMy && getUser.role_id === 3) {
    return false;
  }
  return true;
};

function showPayoutPrice(item) {
  if (item.possible_request_amount) {
    return parseFloat(item.possible_request_amount).toFixed(2);
  }
  if (item.request_amount) {
    return parseFloat(item.request_amount).toFixed(2);
  }
  return parseFloat(0).toFixed(2);
}

function parseDate(date) {
  return new Date(date).toDateString();
}

function parseDate2(date, user) {
  // console.log(user);

  const options = {
    timeZone: "Europe/Rome", // Set the timezone to Europe/Rome
    day: "2-digit", // Two-digit day
    month: "2-digit", // Two-digit month
    year: "2-digit", // Two-digit year
    hour: "2-digit", // Two-digit hour
    minute: "2-digit", // Two-digit minute
    second: "2-digit", // Two-digit second
    hour12: true, // Use 24-hour format
  };

  // Format the date and time according to the options
  return new Date(date).toLocaleString("en-US", options);
}

function handleCouponType(couponType) {
  if (couponType === 1) {
    return "%";
  } else if (couponType === 0 || couponType === 2) {
    return getUserCurrencyCode;
  }
}

function handleOrderStatus(orderStatus, booster, deleted_at) {
  // console.log(booster)
  if (getUser.role_id === 3 && orderStatus === 1) {
    return t("order.status.progress");
  }
  if (deleted_at !== null) {
    return t("order.status.deleted");
  }
  if (orderStatus === 1 && !booster) {
    return t("order.status.not_paid");
  }
  if (orderStatus === 1 && booster?.id) {
    return t("order.status.progress");
  }
  if (orderStatus === 2) {
    return t("order.status.completed");
  }
  return t("order.status.not_paid");
}
</script>
